import { useRouteParams as useRouteParamsBase } from '../../../_hooks/useRouteParams';

interface RouteParamsBase {
  clientId: string;
  draftId: string;
  isFromWorkflow: string;
}

interface RouteParams extends Omit<RouteParamsBase, 'isFromWorkflow'> {
  isFromWorkflow: boolean;
}

export const useRouteParams = (): RouteParams => {
  const params = useRouteParamsBase<RouteParamsBase>();

  return {
    ...params,
    isFromWorkflow: params.isFromWorkflow === 'true',
  };
};
